
import React from 'react';
import { Job } from "@/components/jobs/types";
import { JobLocationField } from './form/JobLocationField';
import { JobEmploymentTypeField } from './form/JobEmploymentTypeField';
import { JobSalaryFields } from './form/JobSalaryFields';
import { JobStatusField } from './form/JobStatusField';
import { JobSkillsField } from './form/JobSkillsField';
import { JobExperienceField } from './form/JobExperienceField';
import { JobSourceUrlField } from './form/JobSourceUrlField';
import { JobDateField } from './form/JobDateField';
import { JobReferenceIdField } from './form/JobReferenceIdField';
import { JobClientInfoField } from './form/JobClientInfoField'; // Import the new component

type JobFormData = Pick<Job, 'location' | 'status' | 'source_url' | 'employment_type'> & {
  skills: string;
  experience_required: string | number;
  salary_min: string | number;
  salary_max: string | number;
};

interface JobOverviewDetailsProps {
  job: Job;
  isEditing: boolean;
  formData: JobFormData;
  onInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onSelectChange: (name: keyof JobFormData, value: string) => void;
  formatDate: (dateString?: string) => string;
}

export const JobOverviewDetails: React.FC<JobOverviewDetailsProps> = ({
  job,
  isEditing,
  formData,
  onInputChange,
  onSelectChange,
  formatDate
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4 text-sm">
      <JobLocationField
        job={job}
        isEditing={isEditing}
        formDataLocation={formData.location}
        onInputChange={onInputChange}
      />
      <JobEmploymentTypeField
        job={job}
        isEditing={isEditing}
        formDataEmploymentType={formData.employment_type}
        onSelectChange={onSelectChange}
      />
      
      <JobSalaryFields
        job={job}
        isEditing={isEditing}
        formDataSalaryMin={formData.salary_min}
        formDataSalaryMax={formData.salary_max}
        onInputChange={onInputChange}
      />
      
      <JobStatusField
        job={job}
        isEditing={isEditing}
        formDataStatus={formData.status}
        onSelectChange={onSelectChange}
      />

      <JobSkillsField
        job={job}
        isEditing={isEditing}
        formDataSkills={formData.skills}
        onInputChange={onInputChange}
      />

      <JobExperienceField
        job={job}
        isEditing={isEditing}
        formDataExperience={formData.experience_required}
        onInputChange={onInputChange}
      />

      <JobSourceUrlField
        job={job}
        isEditing={isEditing}
        formDataUrl={formData.source_url}
        onInputChange={onInputChange}
      />

      {/* Display Client Info - Not editable in this step */}
      {/* This field will only render if client_name or client_id exists */}
      <JobClientInfoField job={job} />
      
      <JobDateField label="Posted" dateString={job.posted || job.created_at} formatDate={formatDate} />
      <JobDateField label="Last Updated" dateString={job.updated_at} formatDate={formatDate} />
      
      <JobReferenceIdField job={job} />
    </div>
  );
};
